import { useManageJobStore } from '@/stores/useManageJob';
import { useMixPanelStore } from '@/stores/useMixPanelStore';
import { jobStates } from '@/constants/manageJobsStatus';

const resetSelectedFiltersAndSortOrder = (storeRef) => {
  storeRef().resetBulkFiltersAndSort();
};

export default function (to, from) {
  if (to.fullPath.includes('/manage-jobs/')) {
    const mixPanelStore = useMixPanelStore();
    let filterStore;

    mixPanelStore.setEventNameTemplateLiteral('manage list');

    const [path] = to.fullPath.split('?');
    // set sub tab value before loading manage jobs page
    switch (path) {
      case `/manage-jobs/${jobStates.pending.slug}`:
        filterStore = usePendingFilterStore;
        mixPanelStore.setSelectedSubtab('pending_subtab');
        break;
      case `/manage-jobs/${jobStates.dispatched.slug}`:
        filterStore = useDispatchedFilterStore;
        mixPanelStore.setSelectedSubtab('dispatched_subtab');
        break;
      case `/manage-jobs/${jobStates.pickedup.slug}`:
        filterStore = usePickedUpFilterStore;
        mixPanelStore.setSelectedSubtab('picked_up_subtab');
        break;
      case `/manage-jobs/${jobStates.delivered.slug}`:
        filterStore = useDeliveredFilterStore;
        mixPanelStore.setSelectedSubtab('delivered_subtab');
        break;
      case `/manage-jobs/${jobStates.active.slug}`:
        filterStore = useActiveFilterStore;
        mixPanelStore.setSelectedSubtab('active_subtab');
        break;
    }

    // dynamically swap filter store depending on current route
    useManageJobStore().setCurrentStore(filterStore);

    // before arriving on manage jobs we need to reset sub filters (e.g. 'Delivery Past Due', 'Needs BOL'...)
    // and reset the sorting options
    if (
      from.fullPath === to.fullPath ||
      !from.fullPath.includes('/manage-jobs') ||
      from.fullPath === '/manage-jobs'
    ) {
      [
        useActiveFilterStore,
        usePendingFilterStore,
        useDispatchedFilterStore,
        usePickedUpFilterStore,
        useDeliveredFilterStore,
      ].map((item) => {
        resetSelectedFiltersAndSortOrder(item);
      });
    }
  }

  if (to.fullPath === '/manage-jobs') {
    return navigateTo({
      path: '/manage-jobs/active',
    });
  }
}
